import React, { useEffect, useState } from 'react';
import {
  Plus,
  ChevronLeft
} from 'react-bootstrap-icons';
import styles from './contact_detail_view_mobile.module.css';
import { CloseIcon, ContactIcon, EditIcon, FacebookIcon, GlobeIcon, LinkdinIcon, MessageIcon, MoreIcon, PhoneIcon, SendIcon, TrashIcon, TwitterIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Avatar, Cell, Column, Divider, Flex, Heading, Item, Link, ListView, TableBody, TableHeader, Row, TextField, View, TableView, MenuTrigger, Menu, ToastQueue } from '@adobe/react-spectrum';
import moment from 'moment';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import { usePreloadAssets } from '../../../../hooks/UsePreloadAssets';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { truncateText } from '../../../../utils/helperUtil';
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';
import { DeleteConfirmationDialog } from '../../finder/components/DeleteConfirmationDialog';
import RelatedContexts from './RelatedContexts';
import ContactTimelineView from './ContactTimelineView';
import { useTranslation } from 'react-i18next';

const ContactDetailViewMobile = ({
  contact,
  contactDataRow,
  listOrganizationFolder,
  employees,
  contactStatusList,
  handleEmployeeClick,
  handleEmployerClick,
  handleEditClick,
  isPerson,
  handleContactDelete,
  navigationStack,
  handleBack,
  handleAddEmployeeRelation,
  handleAddEmployerRelation,
  handleRemoveRelation }: any) => {
  const { contactSettings } = usePreloadAssets();
  const [employeesData, setEmployeesData] = useState<any>([]);
  const { store, mainService } = useDependency();
  let [isOpen, setOpen] = React.useState(false);
  const [result, setResult] = useState<any>([]);
  const {t} = useTranslation();
  useEffect(() => {
    setEmployeesData(employees);
  }, [employees])
  useEffect(() => {
    const data = {
      ...contact,
      ADDRESSES: Array.isArray(contact?.ADDRESSES)
        ? contact.ADDRESSES.map((address: any) => address.ADDRESS)
        : contact?.ADDRESSES?.ADDRESS
          ? [contact.ADDRESSES.ADDRESS]
          : [],
      CONTACTS: Array.isArray(contact?.CONTACTS)
        ? contact.CONTACTS.map((contact: any) => contact.CONTACT)
        : contact?.CONTACTS?.CONTACT
          ? [contact.CONTACTS.CONTACT]
          : [],
      DGROUPS: Array.isArray(contact?.DGROUPS)
        ? contact.DGROUPS.map((contact: any) => contact.DGROUP)
        : contact?.DGROUPS?.DGROUP
          ? [contact.DGROUPS.DGROUP]
          : [],
      RELATIONS: Array.isArray(contact?.RELATIONS)
        ? contact.RELATIONS.map((contact: any) => contact.RELATION)
        : contact?.RELATIONS?.RELATION
          ? [contact.RELATIONS.RELATION]
          : [],
      FOLDERS: Array.isArray(contact?.FOLDERS)
        ? contact.FOLDERS.map((address: any) => address.FOLDER)
        : contact?.FOLDERS?.FOLDER
          ? [contact.FOLDERS.FOLDER]
          : [],
      EMPLOYMENTS: Array.isArray(contact?.EMPLOYMENTS)
        ? contact.EMPLOYMENTS.map((employment: any) => employment.COMPANY)
        : contact?.EMPLOYMENTS?.COMPANY
          ? [contact.EMPLOYMENTS.COMPANY]
          : [],
      INDUSTRIES: Array.isArray(contact?.INDUSTRIES)
        ? contact.INDUSTRIES.map((Industry: any) => Industry.INDUSTRY)
        : contact?.INDUSTRIES?.INDUSTRY
          ? [contact.INDUSTRIES.INDUSTRY]
          : [],
    };
    setResult(data)

  }, [contact])

  const handleFolderClick = (folderId: any) => {
    invokeFinderApp(folderId)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      document.getElementById("top")?.scrollIntoView({ behavior: "smooth" });
    }, 1000); // slight delay to ensure content is rendered

    return () => clearTimeout(timeout);
  }, []);

  const handleEmployeeListClick = (id: any) => {
    const filteredEmployee = employeesData.find((x: any) => x.id === id)
    handleEmployeeClick(filteredEmployee.contact)
  }

  // Required fields to always display
  const requiredFields = ["Mobil", "E-mail", "Telefon"];
  const requiredIcons = ["Facebook", "Twitter", "Linkedin"];

  const getContactDetailsUI = (contact: any): JSX.Element => {
    const contactDetails: Record<string, { value: string | undefined; className: string }> = {};

    const contactsArray: any[] = result.CONTACTS;
    if (!result || !contactsArray) {
      return <View />;
    }

    contactsArray.filter((x: any) => x.isPrimary === '1').forEach((c) => {
      const typeInfo = contactSettings[c.type];
      if (typeInfo) {
        contactDetails[typeInfo.name === 'Fakturační e-mail' ? "E-mail" : typeInfo.name] = {
          value: c.content,
          className: typeInfo.className
        };
      }
    });

    contactDetails["Mobil"] = { value: contactDetails["Mobil"]?.value, className: "mobile-parent" };
    contactDetails["E-mail"] = { value: contactDetails["E-mail"]?.value, className: "e-mail-parent" };
    contactDetails["Telefon"] = { value: contactDetails["Telefon"]?.value, className: "phone-parent" };

    const labelMap: Record<string, string> = {
      "Mobil": "Mobile",
      "Telefon": "Phone"
    };

    requiredFields.forEach((field) => {
      if (!(field in contactDetails)) {
        contactDetails[field] = { value: "N/A", className: `${field.toLowerCase()}-parent` };
      }
    });

    return (
      <View UNSAFE_className={styles['frame-group']}>
        {/* Row 1: Email and Mobile */}
        <View UNSAFE_className={styles.row}>
          {["Mobil", "Telefon"].map((label) => {
            const { value, className } = contactDetails[label] || {};
            const displayLabel = labelMap[label] || label;

            return (
              <View key={label} UNSAFE_className={styles[className]} paddingTop={10}>
                <View UNSAFE_className={styles.mobile}>{displayLabel}</View>
                <View UNSAFE_className={styles.div}>{value || 'N/A'}</View>
              </View>
            );
          })}
        </View>

        {/* Row 2: Phone */}
        <View UNSAFE_className={styles.row}>
          {["E-mail"].map((label) => {
            const { value, className } = contactDetails[label] || {};
            const displayLabel = labelMap[label] || label;

            return (
              <View key={label} UNSAFE_className={styles[className]} paddingTop={10}>
                <View UNSAFE_className={styles.mobile}>{displayLabel}</View>
                <View UNSAFE_className={styles.div}>{value || 'N/A'}</View>
              </View>
            );
          })}
          <View>
            <View UNSAFE_className={styles.mobile}></View>
            {getIconsDetailsUI(contact)}
          </View>
        </View>
      </View>
    );
  };


  const getIconsDetailsUI = (contact: any): JSX.Element => {
    const contactDetails: Record<string, { value: string | undefined; className: string, icon?: JSX.Element }> = {};

    // Extract contacts from response
    const contactsArray: any[] = [];

    if (contact.CONTACTS) {
      if (Array.isArray(contact.CONTACTS)) {
        contactsArray.push(...contact.CONTACTS.map((item: any) => item.CONTACT));
      } else if (contact.CONTACTS.CONTACT) {
        if (Array.isArray(contact.CONTACTS.CONTACT)) {
          contactsArray.push(...contact.CONTACTS.CONTACT);
        } else {
          contactsArray.push(contact.CONTACTS.CONTACT);
        }
      }
    }

    contactsArray.forEach((c) => {
      const typeInfo = contactSettings[c.type];
      if (typeInfo) {
        contactDetails[typeInfo.name] = { value: c.content, className: typeInfo.className };
      }
    });
    contactDetails["Facebook"] = {
      value: contactDetails["Facebook"]?.value,
      className: "icon_facebook", // Fixed className (was "icon_twitter")
      icon: <FacebookIcon size={25} />  // Fixed icon (was TwitterIcon)
    };

    contactDetails["Twitter"] = {
      value: contactDetails["Twitter"]?.value,
      className: "icon_twitter", // Fixed className (was "icon_facebook")
      icon: <TwitterIcon size={25} />
    };

    contactDetails["LinkedIn"] = {
      value: contactDetails["LinkedIn"]?.value,
      className: "icon_linkedin",
      icon: <LinkdinIcon size={25} />
    };

    // Ensure required fields always appear
    requiredIcons.forEach((field) => {
      if (!(field in contactDetails)) {
        contactDetails[field] = {
          value: undefined, // Changed from "N/A" to undefined for better link handling
          className: `icon_${field.toLowerCase()}`
        };
      }
    });

    // Generate UI elements with proper link handling
    return (
      <View UNSAFE_className={styles.iconsstates2}>
        {Object.entries(contactDetails)
          .filter(([label]) => ["Facebook", "Twitter", "LinkedIn"].includes(label))
          .map(([label, { value, className, icon }]) => (
            <View key={label} UNSAFE_className={className}>
              {value ? (
                <Link target='_blank' UNSAFE_className={styles[`${className}_active`]} href={value}>
                  {icon}
                </Link>
              ) : (
                <span>{icon}</span>
              )}
            </View>
          ))}
      </View>
    );
  };

  const handleEmployeeChange = (search: any) => {
    search = search.trim();

    if (search === "") {
      setEmployeesData(employees);
      return;
    }

    const filteredEmployees = employeesData.filter((x: any) =>
      x.name1.toLowerCase().includes(search.toLowerCase()) ||
      x.name3.toLowerCase().includes(search.toLowerCase())
    );

    setEmployeesData(filteredEmployees);
  };

  const addStatusColor = (type: string) => {
    let customStatusName = '';
    if (!contact.FOLDERS) {
      return;
    }
    if (!Array.isArray(contact.FOLDERS)) {
      customStatusName = contact.FOLDERS?.FOLDER?.customStateName;
    } else {
      const filteredFolder = contact.FOLDERS.find((item: any) => item.FOLDER.type === type);
      customStatusName = filteredFolder?.FOLDER?.customStateName;
    }
    if (customStatusName != '') {
      const statusObj = contactStatusList.find((obj: any) => obj.name === customStatusName);
      return statusObj?.color;
    } else {
      return ''
    }
  };

  const copyUrl = () => {
    const url = `${window.location.origin}/contacts?id=${contact?.id}`;
    navigator.clipboard.writeText(url);
    ToastQueue.positive(t('link_copied_to_clipboard', { ns: 'layout_components' }), { timeout: 1000 });
  }

  const getSelectedItm = () => ({
    id: contact?.folderId,
  });

  return (
    <Flex direction={'column'} UNSAFE_className={styles.detailViewParent}>
      <Flex justifyContent={'space-between'}>
        <Flex direction={'row'} gap={'size-100'} UNSAFE_style={{ paddingTop: 0 }}>
          {listOrganizationFolder && listOrganizationFolder.map(((folder: any) => (
            <View key={folder.folderId} UNSAFE_className={styles.tag} UNSAFE_style={{ backgroundColor: addStatusColor(folder.folderTypeId) }}>
              <View UNSAFE_className={styles.mobile}>
                <a onClick={() => handleFolderClick(folder.folderId)}>
                  {folder.folderTypeName}
                </a>
              </View>
            </View>
          )))}
        </Flex>
        <View>
          <View UNSAFE_className={styles.iconsstates1}>
            <ActionButton isQuiet onPress={() => handleEditClick(true)}>
              <EditIcon size={20} />
            </ActionButton>
            <ActionButton isQuiet>
              <TrashIcon size={20} />
            </ActionButton>
            <MenuTrigger>
              <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
              <Menu onAction={copyUrl}>
                <Item key={'copy'}>Copy Link</Item>
              </Menu>
            </MenuTrigger>
          </View>
        </View>
      </Flex>
      <Flex>
        <View UNSAFE_className={styles['icon-contacts-parent']}>
          {navigationStack && navigationStack.length > 0 &&
            <ActionButton isQuiet onPress={handleBack}>
              <ChevronLeft size={20} />
            </ActionButton>
          }
          <b className={styles['adam-novotn']}><span className={
            +contactDataRow?.folderCount > 0 ? styles.contact_icon_orange : styles.contact_icon_grey
          }><Avatar src='/assets/images/avatar--desktop--light@2x.png' size={24} /></span> {contact.name3} {contact.name1}</b>
        </View>
      </Flex>
      <View paddingTop={10} UNSAFE_className={styles['frame-group']}>
        {getContactDetailsUI(contact)}
      </View>
      <View paddingTop={10}>
        <Flex UNSAFE_className={styles['frame-container']} wrap>
          <View UNSAFE_className={styles['mobile-parent']}>
            <View UNSAFE_className={styles.mobile}>Last modification</View>
            <View UNSAFE_className={styles['alena-janik']}>{moment(contact.modified).format('MM/DD/YYYY')}</View>
          </View>
          <View UNSAFE_className={styles['phone-parent']}>
            <View UNSAFE_className={styles.mobile}>Modified by</View>
            <View UNSAFE_className={styles['alena-janik']}>{contact.modifiedByName}</View>
          </View>
          <View UNSAFE_className={styles['created-parent']}>
            <View UNSAFE_className={styles.mobile}>Created</View>
            <View UNSAFE_className={styles.div3}>{moment(contact.created).format('MM/DD/YYYY')}</View>
          </View>
        </Flex>
      </View>
      <Divider marginTop={10} marginBottom={5} size='M' />
      <Flex direction="column" gap="size-200" wrap>
        <View flex>
          <Flex direction={'column'}>
            <b className={styles.address}>Contact Details</b>
            <TableView
              overflowMode="wrap"
              density="spacious"
              UNSAFE_className='tblContactLayoutComponent'
              marginTop={10}
            >
              <TableHeader>
                <Column width={150}>Contact Type</Column>
                <Column>Details</Column>
              </TableHeader>
              <TableBody>
                <Row>
                  <Cell>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <MessageIcon size={18} />
                      <span style={{ marginLeft: '8px' }}>Email</span>
                    </div>
                  </Cell>
                  <Cell>
                    {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '1').map((email: any) => (
                      <div>
                        {email.typeName}: <Link href={`mailto:${email.content}`}> {email.content}</Link>
                      </div>
                    ))}
                  </Cell>
                </Row>
                <Row>
                  <Cell>
                    {/* <div style={{ display: 'flex', alignItems: 'center', padding: '8px', borderRadius: '4px' }}>
              <PhoneFill fontSize={18} />
              <span style={{ marginLeft: '8px' }}>Phone</span>
            </div> */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <PhoneIcon size={18} />
                      <span style={{ marginLeft: '8px' }}>Phone</span>
                    </div>
                  </Cell>
                  <Cell>
                    {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '3' || x.typeType === '2' || x.typeType
                      === '4').map((phone: any) => (
                        <div>
                          {phone.typeName}: <Link href={`tel:${phone.content}`}> {phone.content}</Link>
                        </div>
                      ))}
                  </Cell>
                </Row>
                <Row>
                  <Cell>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <GlobeIcon size={18} />
                      <span style={{ marginLeft: '8px' }}>Web</span>
                    </div>
                  </Cell>
                  <Cell>
                    <div>
                      {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '5').map((phone: any) => (
                        <div>
                          {phone.typeName}: <Link href={`tel:${phone.content}`}> {phone.content}</Link>
                        </div>
                      ))}
                    </div>
                  </Cell>
                </Row>
                <Row>
                  <Cell>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <SendIcon size={18} />
                      <span style={{ marginLeft: '8px' }}>Social media</span>
                    </div>
                  </Cell>
                  <Cell>
                    {result && result.CONTACTS && result.CONTACTS.filter((x: any) => x.typeType === '9' || x.typeType === '10' || x.typeType
                      === '11').map((phone: any) => (
                        <div>
                          {phone.typeName}: <Link href={`tel:${phone.content}`}> {phone.content}</Link>
                        </div>
                      ))}
                  </Cell>
                </Row>
              </TableBody>
            </TableView>
          </Flex>
          {result && result.ADDRESSES && result.ADDRESSES.length > 0 &&
            <View marginTop={10} UNSAFE_className={styles['address-parent']}>
              <b className={styles.address}>Address</b>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.value}>
                  <p className={styles.bristol}>{result.ADDRESSES[0].street}</p>
                  <p className={styles.bristol}>{result.ADDRESSES[0].cityName}</p>
                  <p className={styles.bristol}>{result.ADDRESSES[0].zipName}</p>
                </View>
              </View>
            </View>
          }
          {employeesData && !isPerson &&
            <View marginTop={10} UNSAFE_className={styles['address-parent']}>
              <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                <View UNSAFE_className={styles.address}><b>Employees</b></View>
                <Flex gap="size-100">
                  {/* <ActionButton isQuiet aria-label="Filter">
                  <Filter/>
                </ActionButton> */}
                  <ActionButton isQuiet aria-label="Add" onPress={handleAddEmployeeRelation}>
                    <Plus size={20} />
                  </ActionButton>
                </Flex>
              </Flex>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.value}>
                  {employeesData.map((employee: any) => ((
                    <Flex marginBottom={10} direction={'row'} alignItems="center" justifyContent="space-between" gap={'size-100'} width="100%">
                      <Flex direction="column" gap="size-50" flex="1" minWidth="0">
                        <View UNSAFE_className={styles["employee-name"]}>
                          <Link isQuiet onPress={() => handleEmployeeListClick(employee.id)}>{`${employee.name3} ${employee.name1}`}</Link>
                        </View>
                        <View UNSAFE_className={styles["employee-details"]}>
                          {employee.departmentName && ' | '}
                          {employee.positionName}
                          {employee.departmentName && ` (${employee.departmentName})`}
                        </View>
                      </Flex>
                      <ActionButton
                        isQuiet
                        aria-label="Remove employee"
                        onPress={() => handleRemoveRelation(employee.id)}
                        isDisabled={!employee?.id}
                      >
                        <CloseIcon size={14} />
                      </ActionButton>

                    </Flex>
                  )))}
                </View>
              </View>
            </View>
          }
          {employeesData && isPerson &&
            <View marginTop={10} UNSAFE_className={styles['address-parent']}>
              <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                <View UNSAFE_className={styles.address}><b>Employers</b></View>
                <Flex gap="size-100">
                  {/* <ActionButton isQuiet aria-label="Filter">
                  <Filter/>
                </ActionButton> */}
                  <ActionButton isQuiet aria-label="Add" onPress={handleAddEmployerRelation}>
                    <Plus size={20} />
                  </ActionButton>
                </Flex>
              </Flex>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.value}>
                  {result && result.EMPLOYMENTS?.map((employee: any) => (
                    <Flex marginBottom={10} direction={'row'} alignItems="center" justifyContent="space-between" gap={'size-100'} width="100%">
                      <Flex direction="column" gap="size-50" flex="1" minWidth="0">
                        <View UNSAFE_className={styles["employee-name"]}>
                          <Link isQuiet onPress={() => handleEmployerClick(employee.id)}>{`${employee.name}`}</Link>
                        </View>
                        <View UNSAFE_className={styles["employee-details"]}>
                          {employee.positionInfo} {employee.departmentName && ' | '}
                          {employee.positionName}
                          {employee.departmentName && ' | '}
                          {employee.departmentName}
                        </View>
                      </Flex>
                      <ActionButton
                        isQuiet
                        aria-label="Remove employer"
                        onPress={() => handleRemoveRelation(employee.id)}
                        isDisabled={!employee?.id}
                      >
                        <CloseIcon size={14} />
                      </ActionButton>
                    </Flex>
                  ))}
                </View>
              </View>
            </View>
          }
          {result && result.RELATIONS?.length > 0 &&
            <View marginTop={10} UNSAFE_className={styles['address-parent']}>
              <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
                <View UNSAFE_className={styles.address}><b className={styles.address}>Related Companies</b></View>
                <Flex gap="size-100">
                  {/* <ActionButton isQuiet aria-label="Filter">
                  <Filter/>
                </ActionButton> */}
                  <ActionButton isQuiet aria-label="Add">
                    <Plus size={20} />
                  </ActionButton>
                </Flex>
              </Flex>
              <View UNSAFE_className={styles['value-wrapper']}>
                <View UNSAFE_className={styles.value}>
                  {result.RELATIONS.flat()
                    .map((relation: any) => {
                      // Determine the other company's details dynamically
                      const isMainCompanyContact1 = relation.contact1Id === contact.id;
                      const isMainCompanyContact2 = relation.contact2Id === contact.id;

                      if (!isMainCompanyContact1 && !isMainCompanyContact2) return null;

                      const relatedCompany = isMainCompanyContact1
                        ? { id: relation.contact2Id, name: relation.contact2Name1, type: relation.typeName2 }
                        : { id: relation.contact1Id, name: relation.contact1Name1, type: relation.typeName1 };

                      return (
                        <Flex marginBottom={10} direction={'row'} gap={'size-100'} key={relatedCompany.id}>
                          <View UNSAFE_className={styles["employee-details"]}>
                            <Link isQuiet onPress={() => handleEmployerClick(relatedCompany.id)}>
                              {relatedCompany.name}
                            </Link>
                            {relatedCompany.type && ' | '}
                            {relatedCompany.type}
                          </View>
                        </Flex>
                      );
                    })}

                </View>
              </View>
            </View>
          }
          <RelatedContexts contact={contact} />
        </View>
        <View flex>
          <ContactTimelineView
            contactId={contact.id}
            selectedItem={getSelectedItm()}
            contactStatusList={contactStatusList}
          />
        </View>
      </Flex>
      <DeleteConfirmationDialog
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onConfirm={() => handleContactDelete(contact)}
        itemName={contact?.name1}
      />
    </Flex>
  );
};

export default ContactDetailViewMobile;
